// extracted by mini-css-extract-plugin
module.exports = {"button":"darkButton_button__RzPKP","inverted":"darkButton_inverted__QVqov"};